import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the correct shape of your user object
interface User {
  id: number;
  guid: string;
  firstname: string;
  lastname: string;
  middlename: string;
  username: string;
  email: string;
  mobile: string;
  role: string;
  servicetype: string;
  source: string;
  usercode: string | null;
  status: boolean;
  thirdeyeactive: boolean;
  networkmanager: boolean;
  createdat: string;
  updatedat: string;
  fullname: string;
}

interface Admin {
  username: string;
  phone_no: string;
  email_id: string;
}

interface LoginState {
  user: User | null;
  username: string;
  phone_no: string;
  email_id: string;
  error: string;
  loading: boolean;
  isUserLogout: boolean;
  isLoginError: boolean;
  errorMsg: string;
  loginSuccessMsg: string;
  isAuthenticated: boolean;
  useraccessrights: {accessrights : []}
}

const initialState: LoginState = {
  user: null,
  error: "",
  username: "",
  phone_no: "",
  email_id: "",
  loading: false,
  isUserLogout: false,
  isLoginError: false,
  errorMsg: "",
  loginSuccessMsg: "",
  isAuthenticated: false,
  useraccessrights: {accessrights : []}
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action: PayloadAction<{ data: string }>) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.isLoginError = true;
    },
    userProfileFetchSuccess(state, action: PayloadAction<any>) {
      console.log("inside profile fetch");
      console.log("inside profile fetch action", action.payload);
      state.username = action.payload.username;
      state.email_id = action.payload.email_id;
      state.phone_no = action.payload.phone_no;
      state.loading = false;
      state.isLoginError = false;
      state.isAuthenticated = true;
    },
    loginSuccess(state) {
      state.loading = false;
      state.isLoginError = false;
      state.isAuthenticated = true;
    },
    userAccessRightsSuccess(state, action){
      state.useraccessrights = action.payload;
    },
    userLoginSuccessMsg(state, action: PayloadAction<string>) {
      state.loginSuccessMsg = action.payload;
      state.loading = false;
      state.isLoginError = false;
      state.isAuthenticated = true;
    },
    userLoginErrorMsg(state, action: PayloadAction<string>) {
      state.errorMsg = action.payload;
      state.isLoginError = true;
      state.isAuthenticated = false;
    },
    logoutUserSuccess(state) {
      state.isUserLogout = true;
      state.isAuthenticated = false;
      state.user = null;
    },
    reset_login_flag(state) {
      state.error = "";
      state.loginSuccessMsg = "";
      state.errorMsg = "";
      state.loading = false;
      state.isLoginError = false;
    }
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  userProfileFetchSuccess,
  reset_login_flag,
  userLoginSuccessMsg,
  userLoginErrorMsg,
  userAccessRightsSuccess
} = loginSlice.actions;

export default loginSlice.reducer;
